export enum MetricEnum {
  OEE = "OEE",
  OEE_TOP_DOWN = "OEE_TOP_DOWN",
  OEE_BOTTOM_UP = "OEE_BOTTOM_UP",
  AVAIL = "Availability",
  PERF = "Performance",
  TEEP = "TEEP",
  TEEP_BOTTOM_UP = "TEEP_BOTTOM_UP",
  UPTIME = "Uptime",
  TAGGING = "Tagging",
  TAGGING_BY_EVENT = "Tagging (By Event)",
  TAGGED_COUNT = "Tagged Event Count",
  UNTAGGED_COUNT = "Untagged Event Count",
  PRODUCING_EFFICIENCY = "Producing Efficiency",
  USLE = "USLE",
  OPERATIONAL_AVAILABILITY = "Operational Availability",
  EFFICIENCY = "Efficiency",
  QUALITY = "Quality",
  PURE_EQUIPMENT_UPTIME = "Pure Equipment Uptime",
  OPPORTUNITY = "Opportunity",
  PLANNED_DOWNTIME = "Planned Downtime",

  PRODUCING_PERCENT = "Producing",
  WAITING_DOWNTIME_PERCENT = "Waiting",
  PLANNED_DOWNTIME_PERCENT = "Planned",
  UNPLANNED_DOWNTIME_PERCENT = "Unplanned",
  UNKNOWN_DOWNTIME_PERCENT = "Unknown",
  SPEED_LOSS_PERCENT = "Speed Loss",

  COUNT = "Count", // * legacy
  NET_COUNT = "Net Count", // * duplicate of legacy "Count"
  GROSS_COUNT = "Gross Count",
  REJECT_COUNT = "Reject Count",
  MANUAL_REJECT_COUNT = "Manual Reject Count",
  AUTO_REJECT_COUNT = "Machine Reject Count",
  PROD_POTENTIAL_OUTPUT = "Total Production Count Target",
  TOTAL_POTENTIAL_OUTPUT = "Total Potential Output",

  TICKS_PORT1 = "TicksPort1",
  TICKS_PORT2 = "TicksPort2",
  TICKS_PORT3 = "TicksPort3",
  TICKS_PORT4 = "TicksPort4",

  PRODUCING_TIME = "Producing Time",
  PRODUCTION_TIME = "Production Time",
  PLANNED_TIME = "Planned Time",
  UNPLANNED_TIME = "Unplanned Time",
  WAITING_TIME = "Waiting Time",

  CUSTOM_METRIC_01 = "Custom Metric 01",
  CUSTOM_METRIC_02 = "Custom Metric 02",
  CUSTOM_METRIC_03 = "Custom Metric 03",
  CUSTOM_METRIC_04 = "Custom Metric 04",
  CUSTOM_METRIC_05 = "Custom Metric 05",
  CUSTOM_METRIC_06 = "Custom Metric 06",
  CUSTOM_METRIC_07 = "Custom Metric 07",
  CUSTOM_METRIC_08 = "Custom Metric 08",

  UNTAGGED_PERCENT = "Untagged Percent",
  NOT_SCHEDULED_PERCENT = "Not Scheduled Percent",

  // TODO: Should COLLECTED_TIME be "Collected Time"?
  //
  // This appears as if it should be "Collected Time", but that would
  // change existing reports. Maybe those changes would actually be
  // corrections? What is certain is that making this change breaks the
  // typing in other places. So it remains "Operation Time" for now.
  //
  // Should be? COLLECTED_TIME = "Collected Time",
  //
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  COLLECTED_TIME = "Operation Time",

  OPPORTUNITY_TIME = "Opportunity Time",

  // TODO: Remove eslint-disable, but see COLLECTED_TIME above.
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  OPERATION_TIME = "Operation Time",

  NOT_SCHEDULED_TIME = "Not Scheduled Time",
  UNCOLLECTED_TIME = "Uncollected Time",

  SKU = "SKU",
  SKU_CODE = "Code",
  PROCESS_NAME = "Process Name",
  TARGET_RATE = "Target Rate",
  TARGET_COUNT = "Target Count",

  MEAN_TIME_BETWEEN_FAILURES = "Mean Time Between Failures",
  MEAN_TIME_TO_RECOVERY = "Mean Time To Recovery",
  AVG_CYCLE_TIME = "Avg. Cycle Time",
  AVG_RUN_RATE = "Avg. Run Rate",
  AVG_RUN_RATE_PER_MINUTE = "Avg. Run Rate (/min)",

  BLANK = "",
}

export enum TimeUnitsEnum {
  milliseconds = "milliseconds",
  minutes = "minutes",
  hours = "timeInHours",
  hoursAndMinutes = "hoursAndMinutes",
}

export enum MetricUnitsEnum {
  percent = "%",
  count = "",
}
